/* First-visit Traditional Chinese preference. Explicit locale URLs and manual choices win. */
(() => {
  'use strict';
  const config = window.gpkTraditionalChinese;
  if (!config) return;
  const storage = {
    get(key) { try { return (key === 'gpk_explicit_language' ? localStorage : sessionStorage).getItem(key); } catch (_) { return null; } },
    set(key, value) { try { (key === 'gpk_explicit_language' ? localStorage : sessionStorage).setItem(key, value); } catch (_) {} }
  };
  document.addEventListener('click', (event) => {
    const choice = event.target.closest('a[data-value],button[data-value]');
    const form = choice && choice.closest('form');
    if (form && form.querySelector('[name="locale_code"]')) {
      storage.set('gpk_explicit_language', choice.dataset.value);
    }
  }, true);
  const preferred = (navigator.languages && navigator.languages[0] || navigator.language || '').toLowerCase();
  const traditional = /^(zh-tw|zh-hk|zh-hant(?:-[a-z]{2})?)$/.test(preferred);
  const explicitPath = /^\/(?:fr|de|zh|zh-tw)(?:\/|$)/i.test(location.pathname);
  if (!config.available || config.currentLocale !== 'en' || !traditional || explicitPath ||
      storage.get('gpk_explicit_language') || storage.get('gpk_traditional_auto_attempted') ||
      new URLSearchParams(location.search).has('preview_theme_id') || window.Shopify?.designMode) return;
  storage.set('gpk_traditional_auto_attempted', '1');
  const form = document.createElement('form');
  form.method = 'post';
  form.action = '/localization';
  form.hidden = true;
  for (const [name, value] of Object.entries({
    form_type: 'localization', utf8: '✓', _method: 'put',
    locale_code: 'zh-TW', return_to: location.pathname + location.search
  })) {
    const input = document.createElement('input');
    input.type = 'hidden'; input.name = name; input.value = value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
})();
